export const translations = {
	'Font size': {},
	'Font color': {},
	'Position': {},
	'Visible': {},
	'Hidden': {},
	'Top': {},
	'Middle': {},
	'Bottom': {},
}
